export enum ReactionTypeEnum {
  Like = 'like'
}
